import { serviceHelper } from '../utils/serviceHelper'

export const getServices = async () => {
  const partnerApi = getAxiosCreate()
  const { data } = await partnerApi.get('/services')
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_PARTNER_URL}`)
}
